<template>
     <div class="w3-modal">
      <div class="w3-modal-content w3-card-4"> 
        <header class="w3-container" style="height:45px" @click="cancelDialog" :class="[type==='warning'?'w3-red' : 'w3-theme-d2']"> 
          <span class="w3-button w3-display-topright">&times;</span>
          <slot :meta="meta" name="headercontent"><h3>&nbsp;</h3></slot>
        </header>
        <div class="w3-container dialogcontent">
            <slot :meta="meta">&nbsp;</slot>      
        </div>          
      </div>
    </div>  
</template>

<script>
export default {     
  props:["type"],
  data: function() {
      return {     
        meta:null   
      }
  },
  methods: {  
    show(meta){              
        this.meta = meta||null
        this.$emit('click',{action:'showdialog',data:{meta}})       
        document.getElementById(this.$el.id).style.display = "block"
    },
    cancelDialog(e) { 
        this.$emit('click',{action:'canceldialog',data:{event:e}})       
        document.getElementById(this.$el.id).style.display = "none"
        this.meta = null
    }
  }
};
</script>
 
<style>
  .dialogcontent {
    padding-top: 10px;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/controls/layouts/DialogLayout.vue